module.exports = __webpack_public_path__ + "img/error-icon.c6fdb77c.svg";